module.exports = __webpack_public_path__ + "static/media/tumbledryer.72135a6c.svg";